/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
const MalfunctionRepair = {
  path: '/malfunction-repair',
  name: 'malfunction-repair',
  redirect: { name: 'malfunction-repair-devices' },
  component: () => import('@/views/malfunction-repair/index.vue'),
  children: [
    {
      path: 'devices',
      name: 'malfunction-repair-devices',
      component: () =>
        import(
          /* webpackChunkName: "malfunction-repair" */ '@/views/malfunction-repair/devices.vue'
        ),
    },
    {
      path: 'triage-page',
      name: 'malfunction-repair-triage-page',
      component: () =>
        import(
          /* webpackChunkName: "malfunction-repair" */ '@/views/malfunction-repair/triage-page.vue'
        ),
    },
    {
      path: 'fault-form',
      name: 'malfunction-repair-fault-form',
      component: () =>
        import(
          /* webpackChunkName: "malfunction-repair" */ '@/views/malfunction-repair/fault-form.vue'
        ),
    },
    {
      path: 'order-list',
      name: 'malfunction-repair-order-list',
      component: () =>
        import(
          /* webpackChunkName: "malfunction-repair" */ '@/views/malfunction-repair/order-list.vue'
        ),
    }, // fault-address
    {
      path: 'fault-address',
      name: 'malfunction-repair-fault-address',
      component: () =>
        import(
          /* webpackChunkName: "malfunction-repair" */ '@/views/malfunction-repair/fault-address.vue'
        ),
    },
    {
      path: 'fault-logs',
      name: 'malfunction-repair-fault-logs',
      component: () =>
        import(
          /* webpackChunkName: "malfunction-repair" */ '@/views/malfunction-repair/fault-logs.vue'
        ),
    },
    {
      path: 'fault-log-select',
      name: 'malfunction-repair-fault-log-select',
      component: () =>
        import(
          /* webpackChunkName: "malfunction-repair" */ '@/views/malfunction-repair/fault-log-select.vue'
        ),
    }, // log-analysis
    {
      path: 'log-analysis',
      name: 'malfunction-repair-log-analysis',
      component: () =>
        import(
          /* webpackChunkName: "malfunction-repair" */ '@/views/malfunction-repair/log-analysis.vue'
        ),
    },
    {
      path: 'network-list',
      name: 'malfunction-repair-network-list',
      component: () =>
        import(
          /* webpackChunkName: "malfunction-repair" */ '@/views/malfunction-repair/network-list.vue'
        ),
    },
    {
      path: 'fault-submit',
      name: 'malfunction-repair-fault-submit',
      component: () =>
        import(
          /* webpackChunkName: "malfunction-repair" */ '@/views/malfunction-repair/fault-submit.vue'
        ),
    }, // certificate-form
    {
      path: 'fault-submit-success',
      name: 'malfunction-repair-fault-submit-success',
      component: () =>
        import(
          /* webpackChunkName: "malfunction-repair" */ '@/views/malfunction-repair/fault-submit-success.vue'
        ),
    },
    {
      path: 'certificate-form',
      name: 'malfunction-repair-certificate-form',
      component: () =>
        import(
          /* webpackChunkName: "malfunction-repair" */ '@/views/malfunction-repair/certificate-form.vue'
        ),
    },
    {
      path: 'service-order-detail',
      name: 'malfunction-repair-service-order-detail',
      component: () =>
        import(
          /* webpackChunkName: "malfunction-repair" */ '@/views/malfunction-repair/service-order-detail.vue'
        ),
    },
    {
      path: 'service-order-detail-apply-info',
      name: 'malfunction-repair-service-order-detail-apply-info',
      component: () =>
        import(
          /* webpackChunkName: "malfunction-repair" */ '@/views/malfunction-repair/service-order-apply-info.vue'
        ),
    },
    {
      path: 'repair-order-detail',
      name: 'malfunction-repair-repair-order-detail',
      component: () =>
        import(
          /* webpackChunkName: "malfunction-repair" */ '@/views/malfunction-repair/repair-order-detail.vue'
        ),
    },
    {
      path: 'repair-order-overtime-appeal',
      name: 'malfunction-repair-repair-order-overtime-appeal',
      component: () =>
        import(
          /* webpackChunkName: "malfunction-repair" */ '@/views/malfunction-repair/repair-order-overtime-appeal.vue'
        ),
    },
    {
      path: 'repair-order-duty-result',
      name: 'malfunction-repair-repair-order-duty-result',
      component: () =>
        import(
          /* webpackChunkName: "malfunction-repair" */ '@/views/malfunction-repair/repair-order-duty-result.vue'
        ),
    },
    {
      path: 'repair-order-claim-information',
      name: 'malfunction-repair-repair-order-claim-information',
      component: () =>
        import(
          /* webpackChunkName: "malfunction-repair" */ '@/views/malfunction-repair/repair-order-claim-information.vue'
        ),
    },
    {
      path: 'repair-order-detection',
      name: 'malfunction-repair-repair-order-detection',
      component: () =>
        import(
          /* webpackChunkName: "malfunction-repair" */ '@/views/malfunction-repair/repair-order-detection.vue'
        ),
    },
    {
      path: 'repair-order-report',
      name: 'malfunction-repair-repair-order-report',
      component: () =>
        import(
          /* webpackChunkName: "malfunction-repair" */ '@/views/malfunction-repair/report.vue'
        ),
    },
    {
      path: 'duty-result-appeal',
      name: 'malfunction-repair-duty-result-appeal',
      component: () =>
        import(
          /* webpackChunkName: "malfunction-repair" */ '@/views/malfunction-repair/duty-result-appeal.vue'
        ),
    },
    {
      path: 'pay-success/:sn/:guid/:amount/:orderGuid?/:orderName?',
      name: 'malfunction-repair-pay-success',
      component: () =>
        import(
          /* webpackChunkName: "malfunction-repair" */ '@/views/malfunction-repair/pay-success.vue'
        ),
    },
    {
      path: 'service-bill-detail',
      name: 'malfunction-repair-service-bill-detail',
      component: () =>
        import(
          /* webpackChunkName: "malfunction-repair" */ '@/views/malfunction-repair/service-bill-detail.vue'
        ),
    },
    {
      path: 'upgrade-maintenance-detail',
      name: 'malfunction-upgrade-maintenance-detail',
      component: () =>
        import(
          /* webpackChunkName: "malfunction-repair" */ '@/views/malfunction-repair/upgrade-maintenance-detail.vue'
        ),
    },
    {
      path: 'service-fee-invoice',
      name: 'malfunction-repair-service-fee-invoice',
      component: () =>
        import(
          /* webpackChunkName: "malfunction-repair" */ '@/views/malfunction-repair/service-fee-invoice.vue'
        ),
    },
    {
      path: 'paid-technical-support-order',
      name: 'malfunction-repair-paid-technical-support-order',
      component: () =>
        import(
          /* webpackChunkName: "malfunction-repair" */ '@/views/malfunction-repair/invoice-order/paid-technical-support-order/list.vue'
        ),
    },
  ],
}
export default MalfunctionRepair
